export const api_base_url = "https://mqdata.trotec.com/";
export const webApp_base_url = "https://ttsl.trotec.com";
export const api_headers = {
  Authorization: "Basic bW1jZW50ZXI6ZGxLRC84NzcldW5LISM4OTFfX3I=",
};